import React from 'react';
import connect from '../utils/connect';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { RELO_LOGO } from '../constants/config';

const GetStartedPage = ({ client, startOnboarding }) => {
    const { t } = useTranslation('settings');
    return (
        <div className="gds-flex gds-flex--justify-around gds-flex--content-center onboarding-start">
            <div className="gds-flex__item gds-flex__item--grow-0 gds-flex__item--basis-pct-100 -m-a-1">
                <div className="gds-container -color-bg-white">
                    <h1 className="gds-text--header-lg -text-center">
                        {client.name}
                    </h1>
                    <div className="gds-client__logo -m-v-4">
                        <img
                            src={client.headerImageUrl || RELO_LOGO}
                            height="100%"
                            width="100%"
                            alt={client.name}
                        />
                    </div>
                    <div className="gds-flex gds-flex--justify-around">
                        <div className="gds-flex__item gds-flex__item--grow-0">
                            <button
                                type="button"
                                className="gds-button -m-a-0 gds-button--md gds-button--primary -p-h-5"
                                data-test="onboarding-get-started"
                                onClick={startOnboarding}
                            >
                                {t('clientConfiguration.onboarding.getStarted')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

GetStartedPage.propTypes = {
    client: PropTypes.object.isRequired,
    startOnboarding: PropTypes.func,
};

export default connect(['client'])(GetStartedPage);
